import React, {useState} from 'react';
import {StyleSheet, View, Text, TouchableOpacity} from 'react-native';
import {globalFontStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import withLiveData from '../../../common/withLiveData';
import {globalImport} from '../../../common/globalImports';
import HomeBuySellComp from './HomeBuySellComp';
import {giveCorrectPrice, isMobile} from '../../../utils/commonMethods';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import {
  globalConfigurableData,
  GlobalScreens,
} from '../../../utils/globalConstant';

const MultiChild = props => {
  const {trade, live = null, onBtnPress, isContestCard} = props;
  const [orderBookSelectedData, setOrderBookSelectedData] = useState({
    callvalue: 'Y',
    isShow: false,
  });

  const t = trade;

  let yPrice = 0;
  let nPrice = 0;
  if (t?.type !== 'Bet') {
    return null;
  }

  yPrice = live?.newYCP ?? t?.newYCP;
  nPrice = live?.newNCP ?? t?.newNCP;
  //const live = trade?.live;

  return (
    <View style={{marginVertical: 10}}>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <Text
          style={{color: globalConfigurableData.primaryTextColor1}}
          numberOfLines={1}>
          {t?.alternate_title}
        </Text>
        <View style={{flexDirection: 'row'}}>
          <TouchableOpacity
            style={[
              globalFontStyle.appFontSubText,
              styles.cardBtn,
              {marginRight: 15},
            ]}
            onPress={e => {
              onBtnPress(e, true);
            }}>
            <FormTextLabel
              labelStyles={[
                globalFontStyle.appFontSubText,
                {
                  color: GlobalScreens.Home.yesBtnTxt,
                  textAlign: 'center',
                  fontSize: 16,
                },
              ]}
              label={'Yes '}></FormTextLabel>
            <Text
              style={{
                ...globalFontStyle.appFontHeading,
                color: GlobalScreens.Home.yesBtnTxt,
                fontSize: 16,
                fontWeight: '600',
              }}>
              {isContestCard ? '' : '  ' + (giveCorrectPrice({yPrice: yPrice}) || '  -')}
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={[
              globalFontStyle.appFontSubText,
              styles.cardBtn,
              {
                backgroundColor: GlobalScreens.Home.noBtnBlock,
              },
              globalImport.isWeb ? {} : {flex: 0},
            ]}
            onPress={e => {
              onBtnPress(e, false);
            }}>
            <FormTextLabel
              labelStyles={[
                globalFontStyle.appFontSubText,
                {
                  color: GlobalScreens.Home.noBtnTxt,
                  textAlign: 'center',
                  fontSize: 16,
                },
              ]}
              label={'No '}></FormTextLabel>
            <Text
              style={{
                ...globalFontStyle.appFontHeading,
                color: GlobalScreens.Home.noBtnTxt,
                fontSize: 16,
                fontWeight: '600',
              }}>
              {isContestCard ? '' : '  ' + (giveCorrectPrice({nPrice: nPrice}) || '  -')}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

const getEventId = props => props?.trade?.id;
export default withLiveData(getEventId)(MultiChild);

const styles = StyleSheet.create({
  cardBtn: {
    backgroundColor: GlobalScreens.Home.yesBtnBlock,
    borderRadius: 5,
    paddingVertical: 5,
    textAlign: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    alignItems: 'center',
    width: 100,
  },
});
